import { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { categories } from "@/mocks/homeData";

const dropdownThumbnails: Record<string, string> = {
  "cat-shoes": "https://readdy.ai/api/search-image?query=Single%20pair%20of%20white%20minimalist%20sneakers%20isolated%20on%20pure%20cream%20background%2C%20clean%20product%20photography%2C%20soft%20natural%20daylight%2C%20no%20shadows%2C%20Scandinavian%20style&width=80&height=80&seq=nav-thumb-shoes-v2&orientation=squarish",
  "cat-hoodies": "https://readdy.ai/api/search-image?query=Single%20beige%20oversized%20hoodie%20folded%20neatly%20isolated%20on%20cream%20background%2C%20minimal%20product%20shot%2C%20soft%20lighting%2C%20clean%20Scandinavian%20aesthetic&width=80&height=80&seq=nav-thumb-hoodies-v2&orientation=squarish",
  "cat-tshirts": "https://readdy.ai/api/search-image?query=Single%20white%20cotton%20t-shirt%20neatly%20folded%20isolated%20on%20cream%20background%2C%20minimalist%20product%20photography%2C%20soft%20daylight%2C%20clean%20composition&width=80&height=80&seq=nav-thumb-tshirts-v2&orientation=squarish",
  "cat-jackets": "https://readdy.ai/api/search-image?query=Single%20lightweight%20tan%20jacket%20isolated%20on%20cream%20background%2C%20minimal%20product%20photography%2C%20soft%20natural%20light%2C%20Scandinavian%20style&width=80&height=80&seq=nav-thumb-jackets-v2&orientation=squarish",
  "cat-pants": "https://readdy.ai/api/search-image?query=Single%20pair%20of%20beige%20trousers%20neatly%20folded%20isolated%20on%20cream%20background%2C%20clean%20product%20shot%2C%20soft%20lighting%2C%20minimalist&width=80&height=80&seq=nav-thumb-pants-v2&orientation=squarish",
  "cat-headwear": "https://readdy.ai/api/search-image?query=Single%20stylish%20beige%20cap%20isolated%20on%20cream%20background%2C%20minimalist%20product%20photography%2C%20soft%20natural%20daylight%2C%20clean%20composition&width=80&height=80&seq=nav-thumb-headwear-v2&orientation=squarish",
  "cat-sets": "https://readdy.ai/api/search-image?query=Coordinated%20fashion%20set%20of%20cream%20clothing%20items%20isolated%20on%20cream%20background%2C%20minimal%20product%20photography%2C%20soft%20lighting&width=80&height=80&seq=nav-thumb-sets-v2&orientation=squarish",
  "cat-underwear": "https://readdy.ai/api/search-image?query=Soft%20cotton%20underwear%20neatly%20folded%20isolated%20on%20cream%20background%2C%20minimal%20product%20photography%2C%20soft%20lighting%2C%20clean%20composition&width=80&height=80&seq=nav-thumb-underwear-v2&orientation=squarish",
  "cat-jersey": "https://readdy.ai/api/search-image?query=Single%20sports%20jersey%20isolated%20on%20cream%20background%2C%20minimalist%20product%20photography%2C%20soft%20natural%20daylight%2C%20clean%20Scandinavian%20style&width=80&height=80&seq=nav-thumb-jersey-v2&orientation=squarish",
  "cat-accessories": "https://readdy.ai/api/search-image?query=Elegant%20minimalist%20watch%20isolated%20on%20cream%20background%2C%20clean%20product%20photography%2C%20soft%20lighting%2C%20Scandinavian%20aesthetic&width=80&height=80&seq=nav-thumb-accessories-v2&orientation=squarish",
  "cat-bags": "https://readdy.ai/api/search-image?query=Single%20stylish%20beige%20handbag%20isolated%20on%20cream%20background%2C%20minimalist%20product%20photography%2C%20soft%20natural%20daylight&width=80&height=80&seq=nav-thumb-bags-v2&orientation=squarish",
  "cat-belts": "https://readdy.ai/api/search-image?query=Single%20brown%20leather%20belt%20coiled%20isolated%20on%20cream%20background%2C%20minimal%20product%20photography%2C%20soft%20lighting%2C%20clean%20composition&width=80&height=80&seq=nav-thumb-belts-v2&orientation=squarish",
  "cat-perfumes": "https://readdy.ai/api/search-image?query=Single%20elegant%20glass%20perfume%20bottle%20isolated%20on%20cream%20background%2C%20minimalist%20product%20photography%2C%20soft%20daylight&width=80&height=80&seq=nav-thumb-perfumes-v2&orientation=squarish",
  "cat-otherstuff": "https://readdy.ai/api/search-image?query=Miscellaneous%20fashion%20accessories%20neatly%20arranged%20isolated%20on%20cream%20background%2C%20minimal%20product%20photography%2C%20soft%20lighting&width=80&height=80&seq=nav-thumb-otherstuff-v2&orientation=squarish",
};

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [mobileCatOpen, setMobileCatOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const mobileMenuRef = useRef<HTMLDivElement>(null);
  const menuPanelRef = useRef<HTMLDivElement>(null);
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      const target = e.target as Node;
      const inMenuPanel = menuPanelRef.current && menuPanelRef.current.contains(target);
      const inHamburger = mobileMenuRef.current && mobileMenuRef.current.contains(target);
      if (!inMenuPanel && !inHamburger) {
        setMobileMenuOpen(false);
        setMobileCatOpen(false);
      }
    };
    if (mobileMenuOpen) {
      document.addEventListener("click", handleClickOutside);
    }
    return () => document.removeEventListener("click", handleClickOutside);
  }, [mobileMenuOpen]);

  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setDropdownOpen(false);
      }
    };
    if (dropdownOpen) {
      document.addEventListener("click", handleClick);
    }
    return () => document.removeEventListener("click", handleClick);
  }, [dropdownOpen]);

  const handleMouseEnter = () => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    setDropdownOpen(true);
  };

  const handleMouseLeave = () => {
    timeoutRef.current = setTimeout(() => setDropdownOpen(false), 200);
  };

  const closeMobile = () => {
    setMobileMenuOpen(false);
    setMobileCatOpen(false);
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/98 backdrop-blur-md shadow-[0_1px_3px_rgba(0,0,0,0.04)]"
          : "bg-background-50/85 backdrop-blur-sm"
      }`}
    >
      <div className="w-full px-4 md:px-8 lg:px-16">
        <div className="flex items-center justify-between h-16 md:h-20">
          <Link to="/" className="flex items-center gap-3 group" onClick={closeMobile}>
            <div className="w-9 h-9 md:w-10 md:h-10 rounded-full bg-primary-500 flex items-center justify-center">
              <i className="ri-line-chart-line text-background-50 text-lg"></i>
            </div>
            <span className="font-heading text-lg md:text-xl font-bold text-foreground-950 whitespace-nowrap">
              Hipobuy Spreadsheet
            </span>
          </Link>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-6 lg:gap-8">
            <Link to="/" className="text-sm font-semibold text-foreground-800 hover:text-foreground-950 transition-colors whitespace-nowrap uppercase tracking-wide">
              Accueil
            </Link>

            <div
              ref={dropdownRef}
              className="relative"
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              <button className="flex items-center gap-1 text-sm font-semibold text-foreground-800 hover:text-foreground-950 transition-colors whitespace-nowrap uppercase tracking-wide cursor-pointer">
                Catégories
                <i className={`ri-arrow-down-s-line transition-transform duration-200 text-base ${dropdownOpen ? "rotate-180" : ""}`}></i>
              </button>

              {dropdownOpen && (
                <div className="absolute top-full left-1/2 -translate-x-1/2 mt-3 w-[520px] bg-background-50/98 backdrop-blur-xl rounded-2xl overflow-hidden shadow-[0_8px_30px_rgba(0,0,0,0.08)] border border-background-200">
                  <div className="p-4 grid grid-cols-2 gap-1 max-h-[480px] overflow-y-auto">
                    {categories.map((cat) => (
                      <a
                        key={cat.id}
                        href={cat.url}
                        target="_blank"
                        rel="noopener nofollow"
                        className="flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm text-foreground-700 hover:text-foreground-950 hover:bg-background-100 transition-colors whitespace-nowrap group"
                      >
                        <div className="w-10 h-10 rounded-lg bg-background-100 flex items-center justify-center overflow-hidden flex-shrink-0">
                          <img
                            src={dropdownThumbnails[cat.imageSeq] || dropdownThumbnails["cat-otherstuff"]}
                            alt={cat.name}
                            className="w-full h-full object-cover"
                            loading="lazy"
                          />
                        </div>
                        <span className="font-medium text-xs">{cat.name}</span>
                      </a>
                    ))}
                  </div>
                </div>
              )}
            </div>

            <Link to="/guide-hipobuy-spreadsheet" className="text-sm font-semibold text-foreground-800 hover:text-foreground-950 transition-colors whitespace-nowrap uppercase tracking-wide">
              Guide
            </Link>

            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="text-sm font-semibold text-foreground-800 hover:text-foreground-950 transition-colors whitespace-nowrap uppercase tracking-wide"
            >
              Guide d'Achat
            </a>

            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="text-sm font-semibold text-foreground-800 hover:text-foreground-950 transition-colors whitespace-nowrap uppercase tracking-wide"
            >
              Contact
            </a>
          </div>

          {/* Mobile hamburger */}
          <div className="md:hidden" ref={mobileMenuRef}>
            <button
              onClick={(e) => {
                e.stopPropagation();
                setMobileMenuOpen((prev) => {
                  if (prev) setMobileCatOpen(false);
                  return !prev;
                });
              }}
              className="w-10 h-10 flex items-center justify-center text-foreground-950 cursor-pointer"
              aria-label="Menu"
            >
              <i className={`text-xl ${mobileMenuOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu Panel */}
      {mobileMenuOpen && (
        <div ref={menuPanelRef} className="md:hidden bg-background-50 border-t border-background-200 max-h-[calc(100vh-64px)] overflow-y-auto">
          <div className="px-5 py-4 flex flex-col gap-1">
            <Link to="/" onClick={closeMobile} className="py-3 text-sm font-semibold text-foreground-800 uppercase tracking-wide border-b border-background-100">
              <i className="ri-home-4-line mr-2 text-base"></i>Accueil
            </Link>

            <button
              onClick={(e) => {
                e.stopPropagation();
                setMobileCatOpen((prev) => !prev);
              }}
              className="flex items-center justify-between py-3 text-sm font-semibold text-foreground-800 uppercase tracking-wide border-b border-background-100 cursor-pointer w-full"
            >
              <span><i className="ri-grid-line mr-2 text-base"></i>Catégories</span>
              <i className={`text-base transition-transform ${mobileCatOpen ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"}`}></i>
            </button>

            {mobileCatOpen && (
              <div className="py-2 grid grid-cols-2 gap-1">
                {categories.map((cat) => (
                  <a
                    key={cat.id}
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    onClick={closeMobile}
                    className="flex items-center gap-2 px-2 py-2 rounded-lg text-xs text-foreground-600 hover:text-foreground-950 hover:bg-background-100 transition-colors"
                  >
                    <div className="w-8 h-8 rounded-md bg-background-100 flex items-center justify-center overflow-hidden flex-shrink-0">
                      <img
                        src={dropdownThumbnails[cat.imageSeq] || dropdownThumbnails["cat-otherstuff"]}
                        alt={cat.name}
                        className="w-full h-full object-cover"
                        loading="lazy"
                      />
                    </div>
                    <span className="leading-tight">{cat.name}</span>
                  </a>
                ))}
              </div>
            )}

            <Link to="/guide-hipobuy-spreadsheet" onClick={closeMobile} className="py-3 text-sm font-semibold text-foreground-800 uppercase tracking-wide border-b border-background-100">
              <i className="ri-book-open-line mr-2 text-base"></i>Guide
            </Link>

            <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" onClick={closeMobile} className="py-3 text-sm font-semibold text-foreground-800 uppercase tracking-wide border-b border-background-100">
              <i className="ri-shopping-bag-3-line mr-2 text-base"></i>Guide d'Achat
            </a>

            <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" onClick={closeMobile} className="py-3 text-sm font-semibold text-foreground-800 uppercase tracking-wide">
              <i className="ri-mail-line mr-2 text-base"></i>Contact
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}